import React from "react"

type Props = {
    className?  : string
}

export default function PopoverMenuSeparator(props: Props) {

    const classes = Classes("separator", props.className)

    return (
        <div className={classes}/>
    )

}